/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display relevant advertisements to support our free tier`)
};

const es_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar anuncios relevantes para respaldar nuestro nivel gratuito`)
};

const de_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevante Werbung zur Unterstützung unseres kostenlosen Angebots anzuzeigen`)
};

const nl_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevante advertenties weer te geven ter ondersteuning van ons gratis abonnement`)
};

const fr_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher des publicités pertinentes pour soutenir notre offre gratuite`)
};

const it_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrare pubblicità pertinenti per supportare il nostro livello gratuito`)
};

const pt_br2_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir anúncios relevantes para apoiar nosso plano gratuito`)
};

const pt_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentar anúncios relevantes para apoiar o nosso nível gratuito`)
};

const ja_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料プランをサポートするための関連広告の表示`)
};

const zh_privacy_use_7 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`展示相关广告以支持我们的免费层级`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_7 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_7(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_7", locale)
	if (locale === "en") return en_privacy_use_7(inputs)
	if (locale === "es") return es_privacy_use_7(inputs)
	if (locale === "de") return de_privacy_use_7(inputs)
	if (locale === "nl") return nl_privacy_use_7(inputs)
	if (locale === "fr") return fr_privacy_use_7(inputs)
	if (locale === "it") return it_privacy_use_7(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_7(inputs)
	if (locale === "pt") return pt_privacy_use_7(inputs)
	if (locale === "ja") return ja_privacy_use_7(inputs)
	return zh_privacy_use_7(inputs)
};